<template>
  <div style="padding: 0 10px;">
    <div style="text-align: center;" class="ft14">亲小禾用户协议</div>
    <div class="ft15">发布日期：2022年【11】月【14】日</div>
    <div class="ft14">欢迎您使用亲小禾软件及服务！</div>
    <div class="ft16">特别提醒：</div>
    <div class="ft14">《亲小禾用户协议》是您（以下称“用户”)与厦门亲禾教育科技有限公司（注册地址：厦门市软件园二期望海路63号之二302单元50，联系地址：厦门软件园三期B区19栋22楼，以下简称“亲禾”“本公司”或“我们”）关于您下载、安装、注册、使用亲小禾（以下或称“本服务”“本软件”）所订立的协议。</div>
    <div class="ft14">在您使用本服务之前，请务必仔细阅读并充分理解本协议，特别是加粗并以下划线提示的与您有重大利害关系的条款。若您点击“同意”本协议条款，即表示接受本协议的约束。在阅读本协议的过程中，如果您不同意本协议或其中条款约定，请您停止使用并退出。如您未满18周岁，请立即停止使用并退出。</div>
    <div class="ft14">您理解并同意，为了更好地为您提供服务，我们将对本协议或各项服务规则随时进行修改更新（包括但不限于制定新的条款和修改既有条款）。一旦本协议或服务规则内容发生变更，我们将会在亲小禾App上公布并通知您。修改后的协议在经过公示期后生效并代替原来的协议。如您不同意变更事项，您有权于变更事项确定的生效日前联系我们反馈意见；如反馈意见得以采纳，我们将酌情调整变更事项。如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用本服务，变更事项对您不发生效力。如您在变更事项生效后仍继续使用，则视为您同意已生效的变更事项。</div>
    <div class="ft14">若您对本协议存在疑问，或者在使用过程中需要向我们反馈（含建议、投诉、举报等）的，可以通过以下方式与我们联系：(1)电子邮箱：xiamenqinheeducation@xiaohebook.com或https://www.xiaohebook.com;(2）邮寄方式：福建省厦门市集美区软件园三B区19栋22楼（361001）;(3）电话：18046218090，我们将在收到您联系后的15个工作日内完成身份核查和处理响应。</div>
    <div class="ft16">⦁	关于亲小禾</div>
    <div class="ft14">1．<span class="ft13">服务的内容：</span>亲小禾App是亲禾向用户提供的一种方便幼儿阅读的阅读平台，支持识别获取绘本信息，并以音频方式播放绘本内容的功能。</div>
    <div class="ft14">2．<span class="ft13">软件的获取：</span>您需要下载并注册亲小禾的客户端软件方可使用本服务，您仅可为访问或使用本服务的目的而使用亲小禾。</div>
    <div class="ft14">如果您从未经亲禾授权的第三方获取本软件或与本软件名称相同的安装程序，我们无法保证该软件能够正常使用，并对因此给您造成的损失不承担责任。</div>
    <div class="ft14">3．<span class="ft13">软件的更新：</span>为了改善用户体验、完善服务内容，亲禾将不断努力开发新的服务，并为您不时提供软件更新。我们会在软件替换、修改、更新、升级时在App内向您告知，您可以自行选择更新或仅在技术可支持的条件下继续使用旧版本软件。</div>
    <div class="ft14">4．<span class="ft13">软件的卸载：</span>如果您不再需要使用本软件或者需要安装新版软件，可以自行卸载。如果您愿意帮助亲禾改进产品服务，请告知我们您卸载的原因。</div>
    <div class="ft14">5．<span class="ft13">权利保留：</span>本条款及本协议其他条款未明示授权的其他一切权利仍由亲禾保留，您在行使这些权利时须另外取得我们的书面许可。亲禾如果未行使前述保留的任何权利，并不构成对该权利的放弃。</div>
    <div class="ft14">6．<span class="ft13">第三方服务：</span>您在使用本软件时需要使用到第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。您对第三方应用或功能有任何疑问、意见、建议、投诉、纠纷等，由您自行与该第三方联系和解决。亲禾和第三方对可能出现的任何争议及损害仅在法律规定和约定的范围内各自承担责任。</div>
    <div class="ft16">二、用户信息与个人信息保护</div>
    <div class="ft14">1．我们非常重视用户个人信息的保护，保护用户个人信息是我们的一项基本原则。您理解并同意，我们将按照本协议及《亲小禾隐私政策》（以下简称“隐私政策”）和《儿童隐私政策》的规定收集、使用、存储、管理和保护您或您孩子的个人信息。</div>
    <div class="ft14">请您认真阅读本服务隐私政策以及其他适用的相关声明，并根据自己的实际情况决定是否同意我们收集您或您孩子的个人信息，并做出适当的选择。若您无法接受《隐私政策》或《儿童隐私政策》的全部或者部分条款，或者对隐私政策内容有疑问的，请立即停止使用并退出，您也可根据联系我们。</div>
    <div class="ft16">三、用户注意事项</div>
    <div class="ft14">1．您理解并同意：为了向您提供有效的服务，本软件会利用您移动通讯终端的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。</div>
    <div class="ft14">2．您理解并同意：本软件的某些功能（例如：绘本阅读），需要用户付费购买激活码才能激活使用绘本阅读功能，我们在未收到用户、代理商、幼儿园等注册的情况下，有权单方终止向用户提供该收费功能服务。</div>
    <div class="ft14">3．您理解并同意：本软件中可能包含广告，这属于我们合理合法的商业模式，您同意在使用本软件过程中接收由我们或者其第三方合作伙伴发布的广告信息，以及自行判断广告信息的真实性并为自己的判断行为负责。我们依照法律的规定对广告信息发布履行相关义务后，除法律特别规定外，您因依该广告信息进行的交易或广告主提供的内容而遭受的损失或损害，我们仅在法律规定和约定的范围内承担责任。</div>
    <div class="ft14">4．如果您停止使用本服务或本服务被终止或取消，我们将从服务器上永久地删除您的数据。如您有任何问题，您可以发送电子邮件到【xiamenqinheeducation@xiaohebook.com】联系我们，我们会在15个工作日内完成对您的身份核查和处理响应。</div>
    <div class="ft14">
      5．用户在使用本服务时，须自行承担如下来自亲禾不可掌控的风险内容，包括但不限于：
      <br>(1) 由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；
      <br>(2) 用户须选择与所安装手机相匹配的软件版本，否则，由于软件与手机型号不相匹配所导致的任何问题或损害，由用户自行承担；
      <br>(3) 用户在使用本软件访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；
      <br>(4）由于无线网络信号不稳定、无线网络带宽小等原因，所引起的登录失败、资料同步不完整、页面打开速度慢等风险。
    </div>
    <div class="ft16">四、亲小禾账号规则</div>
    <div class="ft16">1．账号注册规范</div>
    <div class="ft14">您在使用本服务前需要开通一个亲小禾账号。亲小禾账号可通过手机号码进行注册，以便我们在后台进行身份验证并为您开通账号。亲禾有权根据用户需求或产品需求对账号注册和绑定的方式进行变更，并会在亲小禾App上公布并通知。</div>
    <div class="ft14">请您在获得亲小禾账号后自行妥善保管账号及密码，因您保管不善导致的账号与密码失窃、被盗用等情况，责任将由您自行承担。当您怀疑账号被盜或他人在使用您的账号时，您应立即通知我们并联系我们终止您的账号。当您开通账号后长期不使用或未按照法律规定及本协议的约定进行使用的，亲禾有权回收或终止该账号，由此带来的任何损失均由您自行承担。</div>
    <div class="ft16">2．账号的所有权</div>
    <div class="ft14">亲小禾账号的所有权归亲禾所有，用户完成开通账号手续后，仅获得账号的使用权，且该使用权仅属于初始申请开通人。同时，初始申请开通人不得赠与、借用、租用、转让或售卖亲小禾账号或者以其他方式许可非初始申请开通人使用亲小禾账号。非初始申请开通人不得通过受赠、继承、承租、受让或者其他任何方式使用亲小禾账号。否则我们有权在未经通知的情况下警告、限期改正、临时封禁、永久封禁账号等措施，同时停止向您提供任何服务，由此带来的损失由您自行承担，我们不承担违约责任。如亲禾因此而遭受损失的，有权要求用户赔偿损失。</div>
    <div class="ft16">3．账号使用规范</div>
    <div class="ft14">1）登录限制说明</div>
    <div class="ft14">为了保护账号安全，避免账号密码共享泄漏被盗，亲小禾账号仅限个人使用，倘若你需要更换设备登录使用账号，必须通过手机短信验证码进行验证，方可登录，才能继续使用该账号的服务。</div>
    <div class="ft16">五、用户行为规范</div>
    <div class="ft14">
      1．您理解并同意，我们一直致力于为用户提供文明健康、规范有序的网络环境，您不得利用亲小禾账号制作、复制、发布、传播如下信息：
      <br>(1）反对宪法所确定的基本原则的；
      <br>(2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
      <br>(3) 损害国家荣誉和利益的；
      <br>(4）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
      <br>(5）宣扬恐怖主义、极端主义或者动实施恐怖活动、极端主义活动的；
      <br>(6）动民族仇恨、民族歧视，破坏民族团结的；
      <br>(7）破坏国家宗教政策，宣扬邪教和封建迷信的；
      <br>(8）散布谣言，扰乱经济秩序和社会秩序的；
      <br>(9) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
      <br>(10）侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；
      <br>(11）法律、行政法规禁止的其他内容。
    </div>
    <div class="ft14">
      2．除非法律允许或亲禾书面许可，您在使用本服务过程中不得从事下列行为：
      <br>(1）提交、发布虚假信息，或冒充、利用他人名义的；
      <br>(2）虚构事实、隐瞒真相以误导、欺骗他人的；
      <br>(3) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；
      <br>(4）未经亲禾书面许可利用亲小禾账号和任何功能，以及在第三方运营平台进行推广或互相推广的；
      <br>(5）利用亲小禾账号或本软件从事任何违法犯罪活动的；
      <br>(6）制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；
      <br>(7）其他违反法律法规规定、侵犯其他用户合法权益、干扰产品正常运行或亲禾未明示授权的行为。
    </div>
    <div class="ft14">3．您充分了解并同意，您应遵守本协议第四条规定的账号规则，必须为自己所开通的亲小禾账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。亲禾无法且不会对因前述风险而导致的任何损失或损害承担责任。</div>
    <div class="ft14">4．您理解并同意，亲禾有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息并向有关部门报告等，用户应独自承担由此而产生的一切法律责任。因您违反本协议的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任，亲禾因此遭受损失的，您也应当一并赔偿。具体违约责任请见本协议第九条。</div>
    <div class="ft16">六、知识产权</div>
    <div class="ft14">1．除第三方产品或服务外，我们所提供的产品服务，包括但不限于架构、网络／产品页面设计、计算机代码等，均由我们、我们关联企业或我们的合作企业依法拥有知识产权，包括但不限于商标权、专利权、著作权、商业秘密等，以上均受中国法律法规和相应的国际条约保护。我们享有的所有知识产权和相关权益，不因您的任何使用行为而发生任何的权利转移。</div>
    <div class="ft14">
      2．除非法律允许或我们事先书面许可，您在使用本软件过程中不得从事下列行为：
      <br>(1）删除本软件及其副本上关于著作权的信息；
      <br>(2）对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；
      <br>(3) 对我们拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；
      <br>(4）对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非我们授权的第三方系统接入本软件和相关系统；
      <br>(5）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
      <br>(6）通过非亲禾开发、授权的第三方软件、插件、外挂、系统，登录或使用亲禾软件及服务，或制作、发布、传播上述工具；
      <br>(7）自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；
      <br>(8）其他未经亲禾明确授权的行为。
    </div>
    <div class="ft14">3．您在使用本服务过程中，采集绘本信息、提交反馈信息等内容的知识产权（如有）归属于您或原始著作权人所有。如因您上传的内容存在侵权问题或者任何其他的权利疵而引起权利纠纷的，您应当自行解决该等纠纷并独立承担相应的责任；如有任何第三方向我们主张授权内容的权益，您应当为我们积极向第三方抗辩，或者按照我们的要求，为我们向第三方抗辩提供必要的配合与协助（包括但不限于提供与授权内容有关的权利证明文件、资料、信息等）；如因您上传的内容存在侵权问题或者任何其他的权利疵而给我们造成损失的，您应当赔偿我们遭受的全部损失，并消除因前述授权内容的侵权或权利疵问题给我们造成的不良影响。</div>
    <div class="ft14">4．您理解并同意，对于您上传、发布的前述信息，免费授予我们至保护期终止为止、不可撤销的、全球范围的、排他的许可使用权，本有权以自身名义对第三方侵权行为进行取证及提起诉讼。我们有权储存、使用、复制、修订、编辑、发布、展示、翻译、分发、推广、出版、发行、信息网络传播及删除您以上信息内容，有权改变制作演绎作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其他作品内。</div>
    <div class="ft14">5．对于侵犯授权内容的行为，您同意我们有权以我们的名义或者以您的受委托人的名义来自行或委托他人对侵犯授权内容的行为进行维权，维权形式包括但不限于：监测侵权行为、发送维权函、提起诉讼或仲裁、调解、和解等。此种情形下，您进一步同意：我们有权对维权事宜做出决策并独立实施；应我们的要求，您将积极向我们的维权行为提供必要的协助（包括但不限于提供维权所需的必要证明文件、资料、信息等）；维权取得的收益（如有）在扣除我们的维权成本后，按各自一半的比例与我们分享。</div>
    <div class="ft14">6．若您发现本服务内的信息以及用户上传、发布、传播的信息涉嫌侵犯他人知识产权的，请及时通过本协议中所述方式联系我们。</div>
    <div class="ft16">七、终端安全责任</div>
    <div class="ft14">1．您不得制作、发布、使用、传播用于窃取亲小禾账号及他人个人信息、财产的恶意程序。</div>
    <div class="ft14">2．您不得以任何机器人软件、蜘蛛软件、爬虫、刷屏软件等非本认可的方式访问或登录本软件，非法侵入本或他人网络、干扰本或他人网络正常功能、窃取网络数据等危害网络安全的活动。包括但不限于：出于任何目的，在未经授权的情况下使用、破坏或企图破坏、自动攻击、开发或滥用我们的资源或我们的网络安全保护措施，使用任何网络机器人、网络蜘蛛(SPIDER)、抓取工具、抓宠程序、拟人程序或其他非真实用户或避开、破坏技术措施等非正常的自动手段读取、复制、转存访问本软件的任何内容，未经本许可使用插件、外挂或者通过其他第三方工具、运营亲小禾App或任何服务接入本软件和相关系统；</div>
    <div class="ft14">3．您不得对本软件的网络服务及相关软硬件设施进行破解、破坏、删除、修改或者增加，对计算机信息网络中存储或者传输的数据和应用程序进行删除、修改或者增加的；</div>
    <div class="ft14">4．您不得上传、复制、传送、传播任何干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，干扰或破坏本软件或与提供付费服务相连的服务器和网络；</div>
    <div class="ft14">5．您不得向他人提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；</div>
    <div class="ft14">6．您不得明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助的行为，和从事其他违反法律法规，危害计算机网络安全的行为。</div>
    <div class="ft14">7．维护软件安全与正常使用是亲禾和您的共同责任，亲禾将按照行业标准合理审慎地采取必要技术措施保护您的终端设备信息和数据安全，但是您理解并同意亲禾并不能就此承担责任或提供完全的保证。</div>
    <div class="ft16">八、责任限制及不可抗力</div>
    <div class="ft14">1．您理解并同意，本软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于：用户原因、网络服务质量、社会环境、他人非法利用用户资料，进行现实中的骚扰、用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序等，威胁您的终端设备信息和数据安全，继而影响本软件的正常使用。因此，您应加强信息安全及个人信息的保护意识，注意终端安全的保护，以免遭受损失。对因用户终端安全因素造成的损失，亲禾不承担责任。</div>
    <div class="ft14">2．我们向用户提供服务，确保服务的连贯性和安全性，但不能随时预见和防范法律、技术以及其他风险的除外。因不可抗力或者其他意外事件，使得本协议的履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。不可抗力、意外事件是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断、黑客、网路堵塞、电信部门技术调整和政府管制等。</div>
    <div class="ft14">3．您因未能妥善保管、或其他非因我们的原因造成您的账号、登录设备等而导致您的账号、账号内使用权益等丢失、减少及／或因您缺少身份认证或认证信息不真实而无法找回账号、账号内使用权益的，我们不承担任何法律责任。</div>
    <div class="ft14">4．您理解并同意，我们为了整体运营的需要，有权自行决定进行业务变更、调整及技术变更等，有权视情况，随时修改或中断、中止或终止本产品而无需通知您，也无需向您或第三方负责或承担任何赔偿责任，除非法律另有规定或双方另有约定。</div>
    <div class="ft14">5．根据法律法规的要求，我们依据其自身判断，对于您的任何违反或涉嫌违反中国法律或本协议约定的内容，有权视情节删除、屏蔽或断开链接；停止为您提供服务或予以封禁账号；并有权依据中国法律法规之规定保存有关信息并向相关政府部门进行报告。</div>
    <div class="ft14">6．我们仅承担本协议明确约定的直接责任。不论是否可以预见，不论是源于何种形式的行为，我们不对由任何原因造成的特别的、间接的、惩罚性的、突发性的或有因果关系的损害或其他任何损害（包括但不限于利润或利息的损失、经营中断、资料灭失）承担责任。除本协议另有约定外，在任何情况下，我们对本协议所承担的赔偿责任总额不超过我们因向您提供服务而收取的费用总额。</div>
    <div class="ft16">九、违约责任</div>
    <div class="ft14">1．如因您提供的信息不真实、不完整或不准确给亲禾造成损失的，亲禾有权要求您赔偿由此给亲禾造成的损失。亲禾保留在法律允许的范围内因此而拒绝提供服务、删除您账号的权利。</div>
    <div class="ft14">2．如因您违反法律法规规定或本协议约定，在本软件或利用本软件从事非法活动的，亲禾有权立即终止继续对您提供任何服务，并且注销您的账号，并要求您赔偿由此给亲禾造成的损失。</div>
    <div class="ft14">3．如您以技术手段干扰亲禾本软件的运行或干扰其他用户使用本软件，亲禾有权立即停止为您提供服务、注销您的账号，并有权要求您赔偿由此给亲禾造成的损失。</div>
    <div class="ft14">4．如您以虚构事实等方式恶意诋毁我们的商誉，我们有权要求您公开道歉，赔偿您给亲禾造成的损失，并有权终止对您提供亲小禾任何服务。</div>
    <div class="ft14">5．如您存在其他违反有关法律法规规定或违反本协议约定的情形的，我们将根据法律法规和本协议约定，采取违约处理措施（包括但不限于对相关内容进行删除、屏蔽，并视行为情节对违规账号处以包括但不限于警告、限制或禁止使用部分或全部功能、账号封禁、注销等处罚，并公告处理结果）。如您的行为使亲禾及关联公司遭受损失（包括自身的直接经济损失、名誉损失和对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应向亲禾及关联公司赔偿上述全部损失。如您的行为使亲禾及关联公司遭受第三人主张权利，亲禾及关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。</div>
    <div class="ft14">6．若您和我们之间因本协议发生任何争议或纠纷，首先应友好协商解决；协商不成的，提交厦门市集美区人民法院。</div>
    <div class="ft16">十、协议终止</div>
    <div class="ft14">1．用户有权注销亲小禾账号，在此情况下，本协议于账号注销之日终止。</div>
    <div class="ft14">2．我们有权终止本软件，本协议于亲小禾全部服务依法定程序及方式终止之日终止。该等情况下，我们将提前三十日在本软件显著位置持续公示有关信息。在本协议终止时，您应停止对亲小禾的任何使用行为。您不同意我们就终止亲小禾服务而对您或任何第三方承担任何责任。</div>
    <div class="ft14">3．本协议终止后，您无权要求我们继续向您提供任何服务或履行任何其他义务，包括但不限于要求我们为您保留或向您披露其原亲小禾账号中的任何信息，向您或第三方转发任何其未曾阅读或发送过的信息等。</div>
    <div class="ft14">4．本协议的终止不影响守约方向违约方追究违约责任。如您违反本协议规定的任何条款，给我们或其他用户造成损失，则您必须承担全部的赔偿责任。如我们承担了上述责任，则您同意赔偿我们的相关支出和损失，包括合理的律师费用。</div>
    <div class="ft16">十一、通知和送达</div>
    <div class="ft14">1．您在注册成为亲小禾用户，并接受我们的服务时，建议您向我们提供真实有效的联系方式（包括您的电子邮件地址、联系电话等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。您在注册亲小禾用户时生成的用于登录的本账号，也作为您的有效联系方式。</div>
    <div class="ft14">2．我们将向您的上述联系方式的其中之一或其中若干向您送达各类通知，您理解并同意，我们关于本协议内容变化或与您使用本服务相关的通知等均可通过电子邮件、短信提醒、网站公告、产品界面或常规信件传送等任一方式进行。而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。其中以电子的方式发出的书面通知，包括但不限于在亲小禾公告，向您提供的联系电话发送手机短信，向您的账号发送站内信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。</div>
    <div class="ft14">3．对于在本软件上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件、站内信等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、本账号等联系方式为您注册、更新时提供的手机号码以及在注册本用户时生成本账号，司法机关向上述联系方式发出法律文书即视为送达。</div>
    <div class="ft14">4．您同意司法机关可采取以上一种或多种送达方式向您送达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。</div>
    <div class="ft16">十二、法律适用及争议解决</div>
    <div class="ft14">1．本协议签订地为中华人民共和国福建省厦门市集美区。</div>
    <div class="ft14">2．本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</div>
    <div class="ft14">3．若您和我们之间因本协议发生任何争议或纠纷，首先应友好协商解决；协商不成的，您同意将争议或纠纷提交厦门市集美区人民法院管辖。</div>
    <div class="ft14">4．本协议所有条款的标题仅为阅读方便，本身并无实际含义，不能作为本协议含义解释的依据。</div>
    <div class="ft14">5．本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</div>
  </div>
</template>

<script>
export default {
  name: 'AgreementUser'
}
</script>

<style scoped>
.ft13{
  font-weight: 700;
}

.ft14{
  font-size: 14px;
  margin-bottom: 10px;
}

.ft15{
  text-align: right;
  font-size: 14px;
  margin: 0 10px 10px 0;
}

.ft16 {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
}
</style>
